import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';
import type { PageData } from '@swf/core/types/Poker';
import { PKR_INITIAL_STATE } from '@swf/poker';

import effects from './effects';
import {
  gameSelect,
  reset,
  setClubInfo,
  setClubMembers,
  setClubOptions,
  setClubSeasonStats,
  setClubSeasons,
  setError,
  setLoading,
  setPlayerTournamentResults,
  setPlayersByClubId,
  setRecentTournamentSummary,
  setRegisteredTournaments,
  setUiLayout,
  setUserClubs,
  setUserClubsAndGames
} from './reducers';
import selectors from './selectors';

const reducers = {
  setClubInfo,
  setClubMembers,
  setClubOptions,
  gameSelect,
  setLoading,
  setPlayersByClubId,
  reset,
  setUserClubsAndGames,
  setUserClubs,
  setRegisteredTournaments,
  setUiLayout,
  setClubSeasons,
  setError,
  setClubSeasonStats,
  setRecentTournamentSummary,
  setPlayerTournamentResults
};

export interface HomeGamesWidgetModel extends WidgetModelConfig<void, PageData> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const homeGamesWidgetModel: HomeGamesWidgetModel = {
  state: PKR_INITIAL_STATE,
  reducers,
  effects,
  selectors
};

export const useHomeGamesWidget: UseWidget<void, HomeGamesWidgetModel> = useWidget;
